import styled from 'styled-components'

const StyledSelect = styled.select`
  background: white;
  border-style: solid;
  border-color: rgba(188, 190, 192, 0.5);
  border-width: 1px;
  padding: 18px;
  border-radius: 5px;
  text-align: left;
  outline: none;
`

export default StyledSelect
